import React from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import Communication from "components/communication";
import { Pages } from "components/pages";
import { PermissionGuard } from "components/permissions";

const LegacyUnidentifiedRedirect: React.FC = () => {
  const { pageNum } = useParams<{ pageNum: string }>();
  const targetPath = pageNum
    ? `${Communication.Const.basePath}/page/${pageNum}`
    : `${Communication.Const.basePath}`;

  return <Navigate to={targetPath} replace />;
};

const CommunicationsRoute: React.FC = () => (
  <PermissionGuard
    permission={Communication.Const.permissions.VIEW}
    fallback={<Pages.Page403 />}
  >
    <Routes>
      <Route path="/" element={<Pages.Communications />} />
      <Route path="/page/:pageNum" element={<Pages.Communications />} />
      <Route path="/pending" element={<Pages.Communications />} />
      <Route path="/pending/page/:pageNum" element={<Pages.Communications />} />
      <Route path="/unidentified" element={<LegacyUnidentifiedRedirect />} />
      <Route path="/unidentified/page/:pageNum" element={<LegacyUnidentifiedRedirect />} />
      <Route path="/audit" element={<Pages.Communications />} />
      <Route path="/audit/page/:pageNum" element={<Pages.Communications />} />
      <Route path="*" element={<Navigate to={Communication.Const.basePath} replace />} />
    </Routes>
  </PermissionGuard>
);

export default CommunicationsRoute;
